export const FETCH_ALL_TENDLC_ENUMS = 'FETCH_ALL_TENDLC_ENUMS';
export const DONE_FETCHING_ALL_TENDLC_ENUMS = 'DONE_FETCHING_ALL_TENDLC_ENUMS';
export const ERROR_FETCHING_ALL_TENDLC_ENUMS = 'ERROR_FETCHING_ALL_TENDLC_ENUMS';
